import { render } from "./dialog-generate.vue?vue&type=template&id=1d6af328&scoped=true"
import script from "./dialog-generate.vue?vue&type=script&lang=js"
export * from "./dialog-generate.vue?vue&type=script&lang=js"

import "./dialog-generate.vue?vue&type=style&index=0&id=1d6af328&scoped=true&lang=css"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d6af328"]])

export default __exports__